import React from "react";
import ColumnLayout from "@amzn/awsui-components-react/polaris/column-layout";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Select from "@amzn/awsui-components-react/polaris/select";
import {Autosuggest} from "@amzn/awsui-components-react";

export interface ActionRowProps {
    selectedActionName: string;
    selectedActionParamNames: string[];
    selectedActionParamValues: string[];
    selectableActionNames: string[];
    setSelectedAction: (s: string) => void;
    setActionParamValues: (index: number, fieldValue: string) => void;
    getStepOptions: (fieldName: string) => {[value: string]: string}[]
    isEditable: boolean;
}

const ActionRow: React.FC<ActionRowProps> = ({selectedActionName, selectedActionParamNames, selectedActionParamValues, selectableActionNames, setSelectedAction, setActionParamValues, getStepOptions, isEditable})  => {
    const formBody = (
        <ColumnLayout columns={5}>
            <FormField label='Action Name'>
                <Select
                    options={selectableActionNames.map(actionName => ({value: actionName}))}
                    selectedOption={{value: selectedActionName}}
                    onChange={({detail}) => {
                        setSelectedAction(detail.selectedOption.value!)
                    }}
                    disabled={!isEditable}
                />
            </FormField>
            {selectedActionParamNames.map((actionParamName, index) => (
                <div className="InputBox" key={index}>
                    <FormField label={actionParamName}>
                        <Autosuggest
                            onChange={({detail}) => setActionParamValues(index, detail.value.trim())}
                            value={selectedActionParamValues[index]}
                            options={getStepOptions(actionParamName)}
                            enteredTextLabel={value => `Use: "${value}"`}
                            ariaLabel="Autosuggest example with suggestions"
                            placeholder="Enter value"
                            empty="No matches found"
                            disabled={!isEditable}
                        />
                    </FormField>
                </div>
            ))}

        </ColumnLayout>
    )
    return formBody
}

export default ActionRow
